import React, { useState, useEffect } from 'react';
import { Table, Button, Input, Modal, Spin, Row, Col, Tooltip } from 'antd';
import { EditOutlined, SearchOutlined } from '@ant-design/icons';
import apiRequest from '../../hooks/ApiRequest';
import Layouts from '../../components/Layouts';
import ClaimManagerForm from './AddEditClaimManager';
import { toast } from 'react-toastify';

const AssignClaimManagerList = () => {
  const [search, setSearch] = useState('')
  const [baseData, setBaseData] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [selectedClaimManagerID, setClaimManagerSelectedID] = useState()
  const [selectedInsurerID, setInsurerSelectedID] = useState()
  const [insurerList, setInsurerList] = useState([])

  useEffect(() => {
    fetchAssignedClaimManagers()
  }, [modalVisible])

  const fetchAssignedClaimManagers = async () => {
    setLoading(true)
    try {
      const insurers = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/insurer`,
        'GET'
      )
      const insurerIds = insurers?.data.map(ins => ins.id) || []
      localStorage.setItem('allInsurers', insurerIds.join(','))
      setInsurerList(insurers?.data || [])

      const userRole = JSON.parse(localStorage.getItem('roles'))
      const LoggedInUserId = localStorage.getItem('loggedInUserID')

      let userIdStr = []
      if (userRole === 'SuperAdmin') {
        userIdStr = insurerIds
      } else {
        userIdStr.push(parseInt(LoggedInUserId))
      }

      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/GetUserRelationship`,
        'POST',
        userIdStr
      )

      if (res?.success) {
        setBaseData(res.data || [])
      } else {
        toast.error(res?.error || 'Failed to fetch assigned claim managers')
      }
    } catch (error) {
      console.error('Error fetching claim managers:', error)
      toast.error('Something went wrong while fetching data')
    } finally {
      setLoading(false)
    }
  }

  const handleCreate = () => {
    const loggedInUserId = localStorage.getItem('loggedInUserID')
    const loggedInRole = JSON.parse(localStorage.getItem('roles'))
    setSelectedID(0)
    setClaimManagerSelectedID(0)

    if (loggedInRole === 'SuperAdmin') {
      setInsurerSelectedID(0)
    } else {
      setInsurerSelectedID(parseInt(loggedInUserId))
    }
    setModalVisible(true)
  }

  const handleEdit = recordId => {
    const record = baseData.find(item => item.id === recordId)
    if (record) {
      setClaimManagerSelectedID(record.assigneeId)
      setInsurerSelectedID(record.assignorId)
      setSelectedID(record.id)
      setModalVisible(true)
    }
  }

  const handleModalClose = () => {
    setModalVisible(false)
    fetchAssignedClaimManagers()
  }

  const columns = [
    {
      title: 'Insurer',
      key: 'insurerName',
      render: (_, record) => `${record?.assignorName || 'N/A'}`,
    },
    {
      title: 'Claim Manager Name',
      key: 'claimManagerName',
      render: (_, record) => `${record?.assigneeName || 'N/A'}`,
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Tooltip title="Edit Assignment">
          <Button type="primary" onClick={() => handleEdit(record.id)}>
            <EditOutlined />
          </Button>
        </Tooltip>
      ),
    },
  ]

  return (
    <Layouts title="Assign Claim Manager" classname="dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={12}>
            <div className="section-top-heading">
              <h3 style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>
                Assign Claim Manager to Insurers
              </h3>
            </div>
          </Col>

          <Col xs={24} sm={24} md={24} lg={12}>
            <div
              style={{
                display: 'flex',
                gap: '12px',
                alignItems: 'center',
                justifyContent: 'flex-end',
                paddingRight: '12px',
              }}
            >
              <Input
                placeholder="Search by claim manager name..."
                prefix={<SearchOutlined />}
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={{ flex: 1 }}
              />
              <Button type="primary" onClick={handleCreate}>
                Assign Claim Manager
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      {loading ? (
        <Spin size="large" style={{ display: 'block', marginTop: 20 }} />
      ) : (
        <Table
          columns={columns}
          dataSource={baseData.filter(item =>
            item?.assigneeName?.toLowerCase().includes(search.toLowerCase())
          )}
          rowKey="id"
        />
      )}

      <Modal
        title={selectedID ? 'Edit Claim Manager Assignment' : 'Assign Claim Manager'}
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={760}
      >
        <ClaimManagerForm
          InsurerID={selectedInsurerID}
          ClaimManagerID={selectedClaimManagerID}
          recordID={selectedID}
          onSuccess={handleModalClose}
          modalVisible={modalVisible}
        />
      </Modal>
    </Layouts>
  )
}

export default AssignClaimManagerList
